import { ReactNode } from 'react';
import { LocalizedParagraph } from '@mews-commander/ui';
import { Divider, Container, Stack } from '@optimus-web/core';

interface OwnProps {
    rowLabelTextKey: Mews.TextKey;
    rowInfo: ReactNode;
    hideDivider?: boolean;
}

export const SidePanelInfoRowItem = ({ rowLabelTextKey, rowInfo, hideDivider = false }: OwnProps) => (
    <Stack vertical>
        <Container padding={['200', '0']}>
            <Stack spacing="200">
                <LocalizedParagraph variant="secondary" textKey={rowLabelTextKey} />
                {rowInfo}
            </Stack>
        </Container>
        {!hideDivider && <Divider direction="horizontal" />}
    </Stack>
);
